import React from 'react';
import {connect} from 'react-redux';
import cs from 'classnames';
import isObject from 'lodash/isObject';

import {modalClose, modalCloseVerify} from '~/modules/modal/actions';
import KEYS from '~/misc/keys';

import Content from './Content';
import {track} from '~/misc/metrics';

import css from './index.css';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);

    this.modalCloseURI = (...args) => {
      if (this.props.uri === 'dot_validate') {
        return props.dispatch(modalCloseVerify(...args));
      }
      if (isObject(this.props.context)) {
        // 弹窗关闭埋点
        const contxt = this.props.context;
        const source = contxt.source ? contxt.source : '';
        track(source, {eventName: 'close'});
      }
      return props.dispatch(modalClose(...args));
    };
  }

  componentWillUpdate(nextProps) {
    const doEventing = nextProps.uri ? 'addEventListener' : 'removeEventListener';
    document[doEventing]('keydown', this.onKeyPress);

    if (nextProps.uri) {
      document.body.classList.add(css.noScroll);
    } else {
      document.body.classList.remove(css.noScroll);
    }
  }

  render() {
    const {uri, context, dispatch} = this.props;
    if (!uri) {
      return null;
    }
    return (
      <div className={css.wrap}>
        <div className={cs(css.block, css.noScrollBar,{
          [css.overflowDisable]: context._overflowDisable
        })} data-qa='modal'>
          <Content dispatch={dispatch} uri={uri} context={context} />
          {
            context.type !== 'pop_upgrade_to_new_standard' ? (<span className={cs('qa-close', css.closeButton)} onClick={this.close}></span>) : null
          }
        </div>
      </div>
    );
  }

  onKeyPress(e) {
    if (e.keyCode === KEYS.ESC) {
      this.close();
    }
  }

  close() {
    this.modalCloseURI(this.props.uri);
  }
}


export default connect((state) => ({
  uri: state.modal.uri,
  context: state.modal.context,
}))(Modal);



// WEBPACK FOOTER //
// ./src/components/Modal/index.js